/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isDeletionAuthorized, removeStudents }
) => (
  isDeletionAuthorized &&
  <OverlayTrigger
    overlay={<Tooltip id="remove-students-tooltip">Çıkar</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-danger btn-sm"
      onClick={() => removeStudents(row.id)}
    >
      <span className="svg-icon svg-icon-md svg-icon-danger">
        <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")} />
      </span>
    </a>
  </OverlayTrigger>
);